import { cn } from '@/lib/utils';

interface SegmentOption<T extends string> {
  value: T;
  label: string;
}

interface SegmentedControlProps<T extends string> {
  options: SegmentOption<T>[];
  value: T;
  onChange: (value: T) => void;
  disabled?: boolean;
  size?: 'sm' | 'xs';
}

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  disabled = false,
  size = 'sm',
}: SegmentedControlProps<T>) {
  return (
    <div className="inline-flex rounded-full border border-border bg-background p-0.5 gap-0.5 shadow-social-card">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          disabled={disabled}
          onClick={() => onChange(opt.value)}
          className={cn(
            'rounded-full px-2.5 transition-colors font-medium select-none',
            size === 'xs' ? 'py-0.5 text-xs' : 'py-1 text-xs',
            value === opt.value
              ? 'bg-foreground text-secondary shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
            disabled && 'opacity-50 cursor-not-allowed',
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
